import { isPlatformBrowser, Location, LocationStrategy } from "@angular/common";
import { Component, DestroyRef, inject, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { componentDestroyed } from "ng2-rx-componentdestroyed";
import { share, takeUntil } from "rxjs/operators";

import { CommonService } from "@services/common.service";
import { SharedService } from "@services/shared.service";
import { YTBSEOService } from "@services/ytb-seo.service";

import { BOOKING_ERROR_MSG, commonError } from "../../lookup-config"; // properties class containing error msg and error codes
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: "app-global-error-page",
  templateUrl: "./global-error-page.component.html",
  styleUrls: ['./global-error-page.component.scss']
})
export class GlobalErrorPageComponent implements OnInit {
  displayMessage: string;
  moduleType: string;
  error_code: string;
  supplier_code: string;
  btn_message: string;

  contactDetails: Array<any> = [];
  phoneNumber: string = "";
  errorMessageInfo: any = [];
  loginError: boolean = false;
  exceptionInfoMessage: any = {};
  importantLinkDetails:Array<any> = [];
  private destroyRef = inject(DestroyRef);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private shared: SharedService,
    private commonservice: CommonService,
    private ytbseo: YTBSEOService,
    private _location: Location,
    @Inject(PLATFORM_ID) private platformId,
    private location: LocationStrategy
  ) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      history.pushState(null, null, window.location.href);
      this.location.onPopState(() => {
        history.pushState(null, null, window.location.href);
      });
    }
  }


  ngOnInit() {
    this.importantLinkDetails= [
      {label:"Home Page",router:"/"},
      {label:"Phone Support Contact ",router:"/contactus"},
      {label:"Email Support Option ",router:"/chatwithus"},
      {label:" Help Center Link: For FAQs or self-help resources",router:"/help"},
      {label:"Feedback",router:"/feedback"}

    ]

    let urls = this.router.url.split('?');
    setTimeout(() => {

        this.ytbseo.createCanonicalURL(this.router.url);
        this.ytbseo.setDynamicTitle(urls[0]);           
    }, 2000);
  
    this.route.queryParams.subscribe((param) => {
      this.moduleType = param["module"];
      if (this.moduleType == "login") {
        this.loginError = true;
      }
      // console.log(param, "  nagaraju ", param.message);
      // if (param && param.message) {
      //   let params = param.message;
      //   console.log(params, "  nagaraju");
      //   this.errorMessageInfo.push(params);
      // }

      this.shared.errorObjectInfo$.pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((params) => {
      //  let finalMessage = ["We could not able to complete your booking process at this time.",
      //     "Rest assured our team will be checking and resolve",
      //     "For reference please keep this ID with you"+ "this.tempReferenceId" + " "
      //     ]
      // this.exceptionInfoMessage = {
      //   displayMessage : finalMessage,
      // }


        if (params) {
          this.exceptionInfoMessage = params['messageInfo'];
        }
      });


      /** SEO Not needed for error page, just a default title is set for error page  */
      //   let url = this.router.url.split('?');
      //   setTimeout(() => {

      //       this.ytbseo.createCanonicalURL(this.router.url);
      //       this.ytbseo.updateMetaTags(
      //           'desc',
      //           { 'replaceKeywords': { Information: 'Information' } },
      //           'Homepage');
      //   }, 1000);
    });

    this.shared.GeoLocationParam$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((params) => {
      if (params) {
        this.commonservice.getContactUsDetailsByISO2(params.countryCode);
      }
    });

    this.commonservice.OrgContactSuccess$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((orgdtls) => {
      if (orgdtls) {
        this.contactDetails = orgdtls.result;
        this.contactDetails = this.contactDetails.filter(
          (x) => x.contactTypeCode == "PH"
        );

        if (this.contactDetails.length > 0) {
          this.phoneNumber =
            "+" +
            this.contactDetails[0].countryPhoneCode +
            " " +
            this.contactDetails[0].contactValue;
        }
      }
    });

    // if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
    //   localStorage.removeItem("tempRefId");
    // }
  }
  navigateToBack() {
    this.router.navigateByUrl('/')
  }
  ngOnDestroy() {
    this.commonservice.dispose();
  }

  displayError() {
    if (this.moduleType != null && this.error_code != null) {
      switch (this.moduleType) {
        case "FT":
          let flight_error_list = BOOKING_ERROR_MSG.FLIGHT;
          this.displayMessage = this.findErrorMsg(flight_error_list);
          this.btn_message = "Go to Home";
          break;

        case "HT":
          let hotel_error_list = BOOKING_ERROR_MSG.HOTEL;
          this.displayMessage = this.findErrorMsg(hotel_error_list);
          break;

        case "CR":
          let car_error_list = BOOKING_ERROR_MSG.CAR;
          this.displayMessage = this.findErrorMsg(car_error_list);
          break;

        case "SS":
          let activities_error_list = BOOKING_ERROR_MSG.ACTIVITIES;
          this.displayMessage = this.findErrorMsg(activities_error_list);
          break;
        default:
          "";
      }
    } else {
      this.displayMessage = commonError;
    }
  }

  findErrorMsg(error_list) {
    let error_msg_match: any[] = error_list.filter(
      (x) => x.code == this.error_code
    );
    let supplier_error_match = null;
    if (
      error_msg_match[0].supplier_message != undefined &&
      error_msg_match[0].supplier_message != null &&
      error_msg_match[0].supplier_message != ""
    ) {
      supplier_error_match = error_msg_match[0].supplier_message.find(
        (x) => x.code == this.supplier_code
      );
    }
    if (supplier_error_match != null) {
      return supplier_error_match.ytb_message; // show ytb message based on supplier error code
    } else {
      return error_msg_match[0].ytb_message; // show ytb_message based on general error
    }
  }
}
